import { AnimatePresence, motion } from 'framer-motion'
import { Icon } from './Brand'
import { tintMap } from '../data'
import { relTime } from '../lib/time'

export default function ApprovalsPage({ items = [], onResolve = () => {}, role = 'admin' }) {
  const canDecide = role === 'admin'
  return (
    <>
      <motion.div
        className="page-head"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
      >
        <div>
          <div className="eyebrow">Human in the loop</div>
          <h1>Approvals</h1>
          <p className="sub">
            {items.length === 0
              ? 'Nothing waiting on you'
              : `${items.length} pending ${canDecide ? 'your' : "an admin's"} decision`}
          </p>
        </div>
      </motion.div>

      <div className="section-label">Pending</div>

      {items.length === 0 ? (
        <div className="approvals-empty">
          <div className="cs-ic"><Icon name="task_alt" /></div>
          <p>All caught up — no approvals pending.</p>
        </div>
      ) : (
        <div className="approvals-list">
          <AnimatePresence initial={false}>
            {items.map((a) => {
              const tint = tintMap[a.tint] || tintMap.coral
              return (
                <motion.div
                  key={a.id}
                  className="panel approval"
                  layout
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -8, height: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0 }}
                  transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                >
                  <div className="approval-head">
                    <div className="agent-ic" style={{ background: tint.bg }}>
                      <Icon name={a.icon} style={{ color: tint.fg }} />
                    </div>
                    <div>
                      <h3>{a.title}</h3>
                      <div className="ph-sub" style={{ marginBottom: 0 }}>
                        Raised by {a.requester?.name ? `${a.requester.name} · ${a.agent}` : a.agent} · {relTime(a.when)}
                      </div>
                    </div>
                  </div>
                  <p className="approval-detail">{a.detail}</p>
                  <div className="ph-sub" style={{ marginBottom: 12 }}>
                    {canDecide
                      ? 'Override & allow re-runs this request (bypassing the sieve); Uphold block keeps it rejected.'
                      : 'Governance review — an admin decides whether to override or uphold this block.'}
                  </div>
                  {canDecide ? (
                    <div className="approval-actions">
                      <button className="btn-deny" onClick={() => onResolve(a.id, 'denied')}>
                        <Icon name="block" />Uphold block
                      </button>
                      <button className="btn-approve" onClick={() => onResolve(a.id, 'approved')}>
                        <Icon name="check" />Override &amp; allow
                      </button>
                    </div>
                  ) : (
                    <div className="approval-actions">
                      <button className="btn-deny" disabled>
                        <Icon name="block" />Uphold block
                      </button>
                      <button className="btn-approve" disabled>
                        <Icon name="check" />Override &amp; allow
                      </button>
                      <div className="approval-locked">
                        <Icon name="lock" />Requires an admin to decide
                      </div>
                    </div>
                  )}
                </motion.div>
              )
            })}
          </AnimatePresence>
        </div>
      )}
    </>
  )
}
